/**
 * StoreItemOverlay - Mobile slide-in for a single store product.
 *
 * Matches PostOverlay: opens on top of the current route without changing the URL;
 * SlideOverlay handles back, Escape, browser back, and swipe-to-dismiss.
 */

import React, { useEffect, useState } from 'react';
import { getStoreItem } from '../helpers/storeHelpers';
import SlideOverlay from './SlideOverlay';
import StoreItemDetail from '../components/Store/StoreItemDetail';

function StoreItemOverlay({ itemId, onClose }) {
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const open = itemId != null;

  useEffect(() => {
    if (!open) {
      setItem(null);
      setLoading(false);
      setError(false);
      return undefined;
    }
    let cancelled = false;
    setLoading(true);
    setError(false);
    getStoreItem(itemId)
      .then((data) => {
        if (cancelled) return;
        if (data) setItem(data);
        else setError(true);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [open, itemId]);

  return (
    <SlideOverlay
      open={open}
      title="Store"
      onClose={onClose}
      testId="store-item-overlay"
      zIndex={43}
    >
      <>
        {loading && <p className="text-silver text-sm p-4">Loading...</p>}
        {!loading && error && (
          <p className="text-silver text-sm p-4" data-testid="store-item-overlay-error">
            This item is unavailable.
          </p>
        )}
        {!loading && !error && item && (
          <div className="flex h-full min-h-0 flex-1 flex-col overflow-hidden">
            <StoreItemDetail item={item} />
          </div>
        )}
      </>
    </SlideOverlay>
  );
}

export default StoreItemOverlay;
